// Ported from monorepo/src/components/corpus/reading-card.tsx — one
// recommendation as an index card: serif title, mono data rows, the
// double rule before the footer line.
import { Link } from "react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@bindery/ui/components/ui/card";
import type { ReadingCandidate } from "@bindery/shared/corpus/selection";
import { ChallengeScoreBadge } from "./challenge-score-badge";
import { VocabularyAnalysis } from "./vocabulary-analysis";

interface ReadingCardProps {
  candidate: ReadingCandidate;
}

export function ReadingCard({ candidate }: ReadingCardProps) {
  const { id, title, publication, totalWordCount, challengeScore } = candidate;
  const displayTitle = title ?? "Untitled";
  const author = publication?.author;

  return (
    <Card className="gap-4 py-5 transition-shadow hover:shadow-md">
      <CardHeader className="px-5">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <CardTitle className="truncate font-serif text-base font-semibold">
              <Link
                to={`/text/${id}`}
                className="hover:text-primary hover:underline"
              >
                {displayTitle}
              </Link>
            </CardTitle>
            {author && (
              <CardDescription className="mt-0.5 truncate">
                {author}
              </CardDescription>
            )}
          </div>
          <ChallengeScoreBadge score={challengeScore} className="shrink-0" />
        </div>
      </CardHeader>

      <CardContent className="space-y-3 px-5">
        <VocabularyAnalysis candidate={candidate} />

        <div className="catalog-rule text-muted-foreground flex items-center justify-between pt-2.5 text-xs">
          <span className="font-mono tabular-nums">
            {totalWordCount.toLocaleString()} words
          </span>
          {publication?.title && (
            <span className="text-muted-foreground/70 truncate pl-2 text-right">
              {publication.title}
            </span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
